require('./brokerCallMeBackView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { capitalize } = require('lodash');
const { withRouter } = require('react-router-dom');

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { ContentBox } = require('commonsComponents/contentBox');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ components
const {
    BrokerInvestmentSpecialist
} = require('components/broker/brokerInvestmentSpecialist/brokerInvestmentSpecialist');
const { ModalUsPersonBlock } = require('components/commons/modalUsPersonBlock/modalUsPersonBlock');

// @helpers
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;

// @ constants
const { MYPROFILE_BROKER_URL, BROKER_PG_URL } = require('constants/index');

class BrokerCallMeBackView extends React.Component {
    buildBreadcrumb(fromSection) {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText(`breadcrumb-brokerCallMeBack${fromSection}`)
            }
        ];
    }

    render() {
        const { flagBasedFeatures } = this.props;
        const ffUsPersonTransferSecurities = flagBasedFeatures.get('wealth_transfer_securities_to_ok_us_person');
        const fromSection = capitalize(this.props.match.params.section);
        const titleKey = `broker-callMeBack${fromSection}Title`;
        const supportTextKey = `broker-callMeBack${fromSection}SupportText`;
        const breadcrumb = this.buildBreadcrumb(fromSection);
        const goToMyWalletButton = (
            <OKButton to={MYPROFILE_BROKER_URL}>
                <FormattedText value="broker-callMeBackGoToMyInvestments" />
            </OKButton>
        );

        const content = (
            <div className="broker-call-me-back-view">
                <OKCover size="medium">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumb}
                        finalTitle={getFinalTitle(titleKey)} />
                </OKCover>
                <div className="broker-call-me-back-view__body">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-8">
                            <ContentBox customClassName="broker-call-me-back-view__notification-box">
                                <EmptyState
                                    primaryText={formatText(supportTextKey)}
                                    button={goToMyWalletButton}
                                    iconType="nointernet-wealth" />
                            </ContentBox>
                        </div>
                        <div className="col-xs-4">
                            <BrokerInvestmentSpecialist modifier="broker" />
                        </div>
                    </div>
                </div>
            </div>
        )

        return (
            <ModalUsPersonBlock
                children={content}
                featureFlag={ffUsPersonTransferSecurities}
                titleKey={'us_person_popup-transfer_securities_to_ok_title'}
                description={'us_person_popup-transfer_securities_to_ok_message'}
                buttonClick={() => this.props.history.push(BROKER_PG_URL)}
            />
        );
    }
}

BrokerCallMeBackView.propTypes = {
    match: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = BrokerCallMeBackView;
module.exports.BrokerCallMeBackView = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
    }), {

}
)(withRouter(BrokerCallMeBackView));
